import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { IoMdColorFill } from "react-icons/io";
import { FiDelete, FiX, FiClock, FiTrash2 } from "react-icons/fi";
import { expenseTypesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Switch from "components/Switch";
import { TwitterPicker } from "react-color";
import "./ExpenseTypes.scss";
import * as expensesActions from "actions/expensesActions";

class ExpenseTypeEdit extends React.Component {
	constructor(props) {
		super(props);
		console.log(props);

		let expense_type = {
			name: "",
			description: "",
			max_value: "",
			background_color: "",
			border_color: "",
			enabled: true,
		};

		let isEdit = false;

		if (props.expense_type) {
			expense_type = props.expense_type;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			expense_type,
			isBorderPickerVisible: false,
			isBackgroundPickerVisible: false,
		};
	}

	handleChange = (event) => {
		const { expense_type } = this.state;

		this.setState({
			expense_type: {
				...expense_type,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleSwitch = (event) => {
		const { expense_type } = this.state;

		this.setState({
			expense_type: {
				...expense_type,
				[event.target.id]: event.target.checked,
			},
		});
	};

	handleColorChange = ({ hex }, type) => {
		const { expense_type } = this.state;

		if (hex === undefined) hex = "";

		this.setState({
			expense_type: {
				...expense_type,
				[type]: hex,
			},
			isBackgroundPickerVisible: false,
			isBorderPickerVisible: false,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;

		// if edit => update; else => new
		if (this.state.isEdit) {
			response = await expenseTypesService.update(this.state.expense_type);
		} else {
			response = await expenseTypesService.add(this.state.expense_type);
		}

		//console.log(response);

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					this.props.getExpenseTypes();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { expense_type, errors } = this.state;
		const { t } = this.props;
		var isActive = expense_type.enabled;

		const onToggleBackgroundPicker = () =>
			this.setState({
				isBackgroundPickerVisible: !this.state.isBackgroundPickerVisible,
			});
		const onToggleBorderPicker = () =>
			this.setState({
				isBorderPickerVisible: !this.state.isBorderPickerVisible,
			});

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="name">
						<FormLabel>
							{t("expenses.editTypeModal.name")} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={expense_type.name}
							onChange={this.handleChange}
							placeholder={t("expenses.editTypeModal.namePlaceholder")}
							isInvalid={this.checkValidField("name")}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.name}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup className="form-group" controlId="description">
						<FormLabel>{t("expenses.editTypeModal.description")}</FormLabel>
						<FormControl
							as="textarea"
							value={expense_type.description}
							onChange={this.handleChange}
							placeholder={t("expenses.editTypeModal.descriptionPlaceholder")}
							isInvalid={this.checkValidField("description")}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.description}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup className="form-group" controlId="max_value">
						<FormLabel>{this.props.t('expenses.editTypeModal.maxValue')}</FormLabel>
						<FormControl
							type="number"
							min="0"
							step="0.01"
							value={expense_type.max_value}
							onChange={this.handleChange}
							placeholder={this.props.t('expenses.editTypeModal.noLimit')}
							isInvalid={this.checkValidField("max_value")}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.max_value}
						</FormControl.Feedback>
					</FormGroup>

					<Row>
						<Col sm={6}>
							<FormGroup
								controlId="background_color"
								className="form-group form-color"
							>
								<div className="flex-between">
									<FormLabel>{t("expenses.editTypeModal.backgroundColor")}</FormLabel>
									<FiDelete
										className={`icon-remove-color ${!expense_type.background_color && "hidden"} `}
										onClick={() =>
											this.handleColorChange("", "background_color")
										}
									/>
								</div>
								<FormControl
									type="text"
									value={expense_type.background_color}
									placeholder="#FFFFFF"
									readOnly
									isInvalid={this.checkValidField("background_color")}
									style={{
										backgroundColor:
											expense_type.background_color &&
											expense_type.background_color,
									}}
									onClick={onToggleBackgroundPicker}
								/>
								<FormControl.Feedback type="invalid">
									{errors.background_color}
								</FormControl.Feedback>

								<IoMdColorFill onClick={onToggleBackgroundPicker} />

								{this.state.isBackgroundPickerVisible && (
									<div style={{ position: "absolute" }}>
										<TwitterPicker
											color={
												expense_type.background_color
													? expense_type.background_color
													: "#ffffff"
											}
											onChangeComplete={(hex) =>
												this.handleColorChange(hex, "background_color")
											}
										/>
									</div>
								)}
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup
								controlId="border_color"
								className="form-group form-color"
							>
								<div className="flex-between">
									<FormLabel>{t("expenses.editTypeModal.borderColor")}</FormLabel>
									<FiDelete
										className={`icon-remove-color ${!expense_type.border_color && "hidden"} `}
										onClick={() => this.handleColorChange("", "border_color")}
									/>
								</div>

								<FormControl
									type="text"
									value={expense_type.border_color}
									placeholder="#FFFFFF"
									readOnly
									isInvalid={this.checkValidField("border_color")}
									style={{
										backgroundColor:
											expense_type.border_color && expense_type.border_color,
									}}
									onClick={onToggleBorderPicker}
								/>
								<FormControl.Feedback type="invalid">
									{errors.border_color}
								</FormControl.Feedback>

								<IoMdColorFill onClick={onToggleBorderPicker} />

								{this.state.isBorderPickerVisible && (
									<div style={{ position: "absolute" }}>
										<TwitterPicker
											color={
												expense_type.border_color
													? expense_type.border_color
													: "#ffffff"
											}
											onChangeComplete={(hex) =>
												this.handleColorChange(hex, "border_color")
											}
										/>
									</div>
								)}
							</FormGroup>
						</Col>
					</Row>

					<FormGroup
						className="form-group form-group-flex mb0"
						controlId="enabled"
					>
						<FormLabel>{t("common.active")}</FormLabel>
						<Switch
							controlId="enabled"
							isOn={isActive}
							handleToggle={this.handleSwitch}
						/>

						<FormControl.Feedback type="invalid">
							{this.state.errors.enabled}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t("common.save")}
						loadingText={t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

export default connect(mapStateToProps, expensesActions)(withTranslation()(ExpenseTypeEdit));
